export default "__VITE_ASSET__e51bc7f1__"